import Axios from 'axios';

// 监控告警上报：与飞书告警双写，供后端落库统计。
// 不用 AxiosAPI：遥测失败不能触发全局错误通知/SSO 跳转，静默吞掉即可。
const apiPath = { // API地址
  firstScreen: 'https://api.galaxy-future.com/utcollector/website/first_screen/report', // 首屏性能
  digitalHuman: 'website/digital-human/report' // 数字人连接
};

/**
 * 上报原始告警快照（与飞书消息内嵌 JSON 完全一致）
 * @param {string} url 上报地址
 * @param {object} snapshot 告警快照
 */
async function post(url: string, snapshot: any): Promise<any> {
  const baseURL = $ENV.isFormal ? 'https://api.galaxy-future.com/' : 'http://172.16.148.206:1828/';
  return Axios.post(`${ baseURL }${ url }`, snapshot, { timeout: 10000 })
    .catch(() => {}); // 上报失败不影响网页，下次告警会再发
}

/**
 * 上报首屏性能快照
 * @param {object} snapshot firstScreenDiagnostics 组装的快照
 */
export async function AxiosReportFirstScreen(snapshot: any): Promise<any> {
  try {
    // 独立实例隔离业务拦截器；超时、HTTP错误、序列化异常均静默结束，不重试。
    await Axios.create().post(apiPath.firstScreen, snapshot, {
      timeout: 10000,
      headers: { 'Content-Type': 'application/json' },
      withCredentials: false
    });
  } catch { /* 遥测不可用不影响页面，不触发提示或登录跳转。 */ }
}

/**
 * 上报数字人连接告警（失败/中断 failure、慢连接 slow）
 * @param {object} snapshot aidigitalhuman reportConnection 组装的快照
 */
export async function AxiosReportDigitalHuman(snapshot: any): Promise<any> {
  return post(apiPath.digitalHuman, snapshot);
}
